


<template>
  <div>

        <el-form class="select" style="display: flex; flex-wrap: wrap;">

            <!-- <el-form-item label="教师姓名:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择"   v-model="teacherName"  style="width: 100%" clearable  filterable  >
                <el-option v-for="item in teacherArr"  :key="item.id"  :value="item.id"  :label="item.realname" >  </el-option>
              </el-select>
            </el-form-item> -->

             <el-form-item label="学科组:" label-width="100px" style="width: 30%;" >
              <el-select  placeholder="请选择学科组"  v-model="SubjectGroup"  style="width: 100%" clearable  filterable  >
                 <el-option v-for="item in SubjectGroupList" :key="item.id" :label="item.teacherName"  :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="老师状态:" label-width="100px" style="width: 30%;">
              <el-select v-model="teacherStatus"  filterable placeholder="请选择老师状态"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in teacherStatusList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="学生类型:" label-width="100px" style="width: 30%;">
              <el-select v-model="newClassType"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择所在地域"  v-model="regionName"  style="width: 100%"   clearable  filterable  >
                <el-option  v-for="item in optionsListt" :key="item.id"  :value="item.dictType"  :label="item.dictValue"  >  </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="首次课日期:" label-width="100px" style="width: 50%;text-align: justify;">
              <el-date-picker v-model="dateTimeList"   type="daterange"  style="width: 100%;"   value-format="yyyy-MM-dd"   range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期">   </el-date-picker>
            </el-form-item>
        </el-form>


        <div style=" text-align: end; padding: 10px;">
          <el-button @click="handleClear" icon="el-icon-close" size="small" class="btns">清除</el-button>
          <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
          <el-button type="primary" icon="el-icon-download" size="small" class="btns" @click="handleDownload">导出</el-button>
        </div>



    <div style="margin-top: 15px;">

      <div style="display: flex;justify-content: space-between;margin-bottom: 10px;margin-top: 10px;" v-for="(item,index) in dateList" :key="index" class="chart-item">

        <el-card style="width: 35%; border-radius: 15px;">
          <div ref="charts" :id="`chart-chart`" style="width: 100%; height: 180px;"></div>
        </el-card>

        <el-card style="width: 20%; border-radius: 15px;">
            <div style="text-align: center;">线下</div>
            <div style="display: flex; margin-top: 10px;">
              <div :id="`offline-pie-${index}`" style="width: 100%; height: 180px; margin-top: 10px;"></div>
            </div>
        </el-card>

        <el-card style="width: 20%; border-radius: 15px;">
            <div style="text-align: center;">规划</div>
            <div style="display: flex; margin-top: 10px;">
              <div :id="`plan-pie-${index}`" style="width: 100%; height: 180px; margin-top: 10px;"></div>
            </div>
        </el-card>

        <el-card style="width: 20%; border-radius: 15px;">
            <div style="text-align: center;">纯补课</div>
            <div style="display: flex; margin-top: 10px;">
              <div :id="`makeup-pie-${index}`" style="width: 100%; height: 180px; margin-top: 10px;"></div>
            </div>
        </el-card>

      </div>

    </div>


    <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataTableList" border height="700">
        <el-table-column prop="subjectGroupName" header-align="center"  label="学科组" ></el-table-column>
        <el-table-column prop="manageName" header-align="center"  label="学管姓名" ></el-table-column>
        <el-table-column prop="entiretySuccess" header-align="center"  label="整体成功率" ></el-table-column>
        <el-table-column prop="offlineSuccess" header-align="center"  label="线下成功率" ></el-table-column>
        <el-table-column prop="projectSuccess" header-align="center"  label="规划成功率" ></el-table-column>
        <el-table-column prop="cramSuccess" header-align="center"  label="纯补课成功率" ></el-table-column>
        <el-table-column header-align="center" label="查看详情" width="150px">
          <template slot-scope="scope">
            <el-button type="text" @click="details(scope.row)">详情</el-button>
          </template>
        </el-table-column>
    </el-table>

     <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"  :current-page="pageNum" :page-size="pageSize"  
        layout="prev, pager, next,sizes, jumper" :total="total">
     </el-pagination>

    <el-dialog width="80%" :visible.sync="showPopUpNotification" :before-close="showPopUpNotificationCler" :close-on-click-modal="false" modal-append-to-body :append-to-body="true">
        <fistClassComponents v-if="showPopUpNotification" :paramsComponents="params_ZUJIAN"></fistClassComponents>
    </el-dialog>

   
  </div>
</template>



<script>

import axios from "axios";
import apiBaseUrl from "../../../config/api";
import { getTeachers_s,getTeachers_ss  } from "@/api/firstClassApi";
import * as echarts from 'echarts';
import loadingUtils from "../../utils/loading";
import fistClassComponents from '../fistClass.vue';



export default {
  name: 'FistClassTableTeacherEnd',
  components: {
    fistClassComponents,
  },
  props: {
    type: {
      type: String,
      default: '未知'
    },
  },
  data() {
    return {

      teacherName: '',
      teacherArr: [],

      newClassType: '',
      newClassTypeList: [
        {id:1,name:'规划'},
        {id:2,name:'线下'},
        {id:3,name:'纯补课'},
      ],

      teacherStatusList: [
        {id:1,name:'在职'},
        {id:2,name:'离职'},
        {id:5,name:'全部'}
      ],

      teacherStatus: 5,

      regionName: '',
      optionsListt: [],

      dateTimeList: [],


      showPopUpNotification: false,
      params_ZUJIAN: null,



      dateList: [{}], // 用于存储日期列表
      calculationType: 1, // 1: 差异率, 2: 差值, 3: 无差异率


      dataTableList: [], // 用于存储表格数据

      chartData:[{}], // 用于存储图表数据


      pageSize: 10,
      pageNum: 1,
      total: 0,

      SubjectGroupList: [],
      SubjectGroup:'',
       
    }
  },

  computed: {
   
  },

  mounted() {

    this.SubjectGroupList = JSON.parse(sessionStorage.getItem('SubjectGroupList'))

    getTeachers_ss().then((res) => {  this.teacherArr = res.data   })
    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
       this.optionsListt = res.data.data
    })

    this.dateTimeList = this.getDefaultDateRange()

    this.handleGetDateList()

  },

  methods: {

    formatDate(date) {
          const y = date.getFullYear();
          let m = date.getMonth() + 1; // Months are zero based
          let d = date.getDate();
          m = m < 10 ? '0' + m : m;
          d = d < 10 ? '0' + d : d;
          return `${y}-${m}-${d}`;
    },


    getDefaultDateRange() {
        const today = new Date();
        const year = today.getFullYear();
        let startMonth = today.getMonth() - 6; // 半年前的月份
        let startYear = year;
        
        // 调整年份和月份，确保开始月份正确
        if (startMonth < 0) {
            startMonth += 12;
            startYear -= 1;
        }
        
        // 开始日期总是当月的第一天
        const startDate = new Date(startYear, startMonth, 1);
        
        // 结束日期是当前月份的最后一天
        const endYear = today.getFullYear();
        const endMonth = today.getMonth();
        const endDate = new Date(endYear, endMonth + 1, 0); // 0表示前一个月的最后一天

        return [this.formatDate(startDate), this.formatDate(endDate)];
    },


    handleSizeChange(e){
       this.pageSize = e
       this.handleGetDateList()
    },

    handleCurrentChange(e){
       this.pageNum = e
       this.handleGetDateList()
    },


    showPopUpNotificationCler() {
      this.params_ZUJIAN = null;
      this.showPopUpNotification = false;
    },


    details(row) {
      this.params_ZUJIAN = {
        teacherId:row.teacherId,
        startTime: this.dateTimeList .length > 1 ? this.dateTimeList[0] : '',
        endTime: this.dateTimeList .length > 1 ? this.dateTimeList[1] : '',
        regionName: this.regionName,
        classType: this.newClassType,
        teacherStatus: this.teacherStatus,
        subjectGroupId: row.subjectGroupId,
      };
      this.showPopUpNotification = true;
    },

    handleSearch() {
       this.pageNum = 1
       this.pageSize = 10
       this.handleGetDateList();
    },

    handleClear() {
      this.SubjectGroup = ''
      this.teacherName = '';
      this.teacherStatus = 5
      this.newClassType = '';
      this.regionName = '';
      this.dateTimeList = this.getDefaultDateRange() ;
      this.pageSize = 10
      this.pageNum = 1
      this.total = 0

      this.handleGetDateList();
    },

    handleDownload(){

      loadingUtils.startLoading();

      let data = { 
          pageIndex: this.pageNum,
          pageSize: this.pageSize,
          startTime: this.dateTimeList .length > 1 ? this.dateTimeList[0] : '',
          endTime: this.dateTimeList .length > 1 ? this.dateTimeList[1] : '',
          teacherId: this.teacherName,
          regionName: this.regionName,
          classType: this.newClassType,
          teacherStatus: this.teacherStatus,
          subjectGroupId: this.SubjectGroup,
          exportType: 2
      }

      let url = this.type === '首次课图表' ? '/firstRecordDiagram/exportSubjectFirstDiagram' :
                  this.type === '新增率图表' ? '/classSales/exportStatistics' :
                    this.type === '到课率图表' ? '/scheduleComplete/exportTeacherSchedule' :
                      this.type === '取消率图表' ? '/lossCourseDiagram/queryTeacherCourseDiagram' :
                        this.type === '流失率图表' ? '/classSales/exportStatistics' :
                          this.type === '续报率图表' ? '/continuedReport/queryTeacherContinuedReportDiagram' : '/classSales/exportStatistics'

      let xlsxName = this.type === '首次课图表' ? '首次课学科组统计完成率' :
                        this.type === '新增率图表' ? '新增率图表' :
                          this.type === '到课率图表' ? '到课率图表' :
                            this.type === '取消率图表' ? '取消率图表' :
                              this.type === '流失率图表' ? '流失率图表' :
                                this.type === '续报率图表' ? '续报率图表' : ''


      axios.post(`${apiBaseUrl}${url}`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((response) => {
        const blob = new Blob([response.data], { type: "application/vnd.ms-excel"})
      
        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)

        const downloadLink = document.createElement("a")
        downloadLink.href = URL.createObjectURL(blob)
        downloadLink.download = xlsxName + ".xlsx"
        downloadLink.click()
      }).catch((error) => {
        this.$message.error(error)
        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)
      })

    },




    initCharts() {
      // this.handleGetDateList();

      loadingUtils.startLoading();
      const charts = document.querySelectorAll('.chart-item  div[id^="chart-"]')
      const ele = document.getElementById('chart-chart')

      this.$nextTick(()=>{
        charts.forEach((chart, index) => {


            if (!this.dateList[index]) return;


            let chartInstance = echarts.init(ele)
            let option = this.getChartOption(index)
            option && chartInstance.setOption(option)


            // 线下饼图
            let offlinePie = echarts.init(document.getElementById(`offline-pie-${index}`));
            offlinePie.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
                        return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
                    },
                },
                legend: {
                    orient: 'horizontal',
                    left: 'center',
                    top: -5,
                    data: ['已成功', '未成功', '未知'],
                    left: 'left',
                    icon: 'circle', // 让图例变成圆点
                    selectedMode: false 
                },
                series: [{
                    type: 'pie',
                    radius: '40%',
                    center: ['50%', '60%'],
                    data: [
                        { 
                          percent: this.chartData[index] && this.chartData[index].offlineSuccessNum ? this.chartData[index].offlineSuccessNum : 0,
                          isCopyNane: 2, 
                          value: this.chartData[index] && this.chartData[index].offlineSuccess ? this.chartData[index].offlineSuccess : 0, 
                          name: '已成功' 
                        },
                        { 
                          percent: this.chartData[index] && this.chartData[index].offlineBlankNum  ? this.chartData[index].offlineBlankNum   : 0,
                          isCopyNane: 2, 
                          value: this.chartData[index] && this.chartData[index].offlineBlank ? this.chartData[index].offlineBlank : 0, 
                          name: '未成功' 
                        },
                        { 
                          percent: this.chartData[index] && this.chartData[index].offlineUnknownNum ? this.chartData[index].offlineUnknownNum : 0,
                          isCopyNane: 2, 
                          value: this.chartData[index] && this.chartData[index].offlineUnknown ? this.chartData[index].offlineUnknown : 0, 
                          name: '未知' 
                        },
                    ],
                    label: {
                      formatter: function (params) {
                        return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
                      },
                    }
                }],
                color: ['#4472c4', '#3dc6c1', '#f6c846']
            });

            // 规划饼图
            let planPie = echarts.init(document.getElementById(`plan-pie-${index}`));
            planPie.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
                      return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
                    },
                },
                legend: {
                    orient: 'horizontal',
                    left: 'center',
                    top: -5,
                     data: ['已成功', '未成功', '未知'],
                    left: 'left',
                    icon: 'circle', // 让图例变成圆点
                    selectedMode: false 
                },
                series: [{
                    type: 'pie',
                    radius: '40%',
                    center: ['50%', '60%'],
                    data: [
                        { 
                          percent: this.chartData[index] && this.chartData[index].projectSuccessNum ? this.chartData[index].projectSuccessNum : 0,
                          isCopyNane: 1, 
                          value: this.chartData[index] && this.chartData[index].projectSuccess ? this.chartData[index].projectSuccess : 0, 
                          name: '已成功'
                         },
                        { 
                          percent: this.chartData[index] && this.chartData[index].projectBlankNum ? this.chartData[index].projectBlankNum : 0,
                          isCopyNane: 1, 
                          value: this.chartData[index] && this.chartData[index].projectBlank ? this.chartData[index].projectBlank : 0, 
                          name: '未成功'
                         },
                        { 
                          percent: this.chartData[index] && this.chartData[index].projectUnknownNum ? this.chartData[index].projectUnknownNum : 0,
                          isCopyNane: 1, 
                          value: this.chartData[index] && this.chartData[index].projectUnknown ? this.chartData[index].projectUnknown : 0, 
                          name: '未知'
                         },
                    ],
                    label: {
                      formatter: function (params) {
                        return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
                      },
                    }
                }],
                color: ['#4472c4', '#3dc6c1', '#f6c846']
            });

            // 纯补课饼图
            let makeupPie = echarts.init(document.getElementById(`makeup-pie-${index}`));
            makeupPie.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
                      return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
                    },
                },
                legend: {
                    orient: 'horizontal',
                    top: -5,
                    data: ['已成功', '未成功', '未知'],
                    left: 'left',
                    icon: 'circle', // 让图例变成圆点
                    selectedMode: false 
                },
                series: [{
                    type: 'pie',
                    radius: '40%',
                    center: ['50%', '60%'],
                    data: [
                        { 
                          percent: this.chartData[index] && this.chartData[index].cramSuccessNum ? this.chartData[index].cramSuccessNum : 0,
                          isCopyNane: 3, 
                          value: this.chartData[index] && this.chartData[index].cramSuccess ? this.chartData[index].cramSuccess : 0, 
                          name: '已成功' 
                        },
                        { 
                          percent: this.chartData[index] && this.chartData[index].cramBlankNum ? this.chartData[index].cramBlankNum : 0,
                          isCopyNane: 3, 
                          value: this.chartData[index] && this.chartData[index].cramBlank ? this.chartData[index].cramBlank : 0, 
                          name: '未成功' 
                        },
                        { 
                          percent: this.chartData[index] && this.chartData[index].cramUnknownNum ? this.chartData[index].cramUnknownNum : 0,
                          isCopyNane: 3, 
                          value: this.chartData[index] && this.chartData[index].cramUnknown ? this.chartData[index].cramUnknown : 0,
                           name: '未知' 
                        },
                    ],
                    label: {
                      formatter: function (params) {
                         return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
                      },
                    }
                }],
                color: ['#4472c4', '#3dc6c1', '#f6c846']
            });


            // params 包含点击的数据项信息
           chartInstance.on('click', params => {
               console.info(params);
               params.classStateType = 0
               params.stateType = params.data && params.data.name === '未成功' ? 0 :  params.data && params.data.name === '未知' ? 'null' : params.data && params.data.name === '已成功' ? 1 : 2
               params.isEntirety = 1
               params.isType = 1

               params.regionName = this.regionName
               params.classType = this.newClassType
               params.teacherId = this.teacherName

               params.data.customSeriesInfo = {  startTime: this.dateTimeList.length > 0 ? this.dateTimeList[0] : '', endTime: this.dateTimeList.length > 0 ? this.dateTimeList[1] : '' }

               params.teacherStatus = this.teacherStatus,
               params.subjectGroupId = this.SubjectGroup

               this.params_ZUJIAN = params;
               this.showPopUpNotification = true;
           });

            // 线下饼图
           offlinePie.on('click', params => {
              console.info(params);
              params.stateType = params.data && params.data.name === '未成功' ? 0 :  params.data && params.data.name === '未知' ? 'null' : params.data && params.data.name === '已成功' ? 1 : 2
              params.isEntirety = 0
              params.isType = 1

              params.regionName = this.regionName
              params.classType = this.newClassType
              params.teacherId = this.teacherName

              params.data.customSeriesInfo = {  startTime: this.dateTimeList.length > 0 ? this.dateTimeList[0] : '', endTime: this.dateTimeList.length > 0 ? this.dateTimeList[1] : '' }
              params.classStateType = params.data.isCopyNane

              params.teacherStatus = this.teacherStatus,
              params.subjectGroupId = this.SubjectGroup

              this.params_ZUJIAN = params;
              this.showPopUpNotification = true;
           });

            // 规划饼图
           planPie.on('click', params => {
                console.info(params);
                params.stateType = params.data && params.data.name === '未成功' ? 0 :  params.data && params.data.name === '未知' ? 'null' : params.data && params.data.name === '已成功' ? 1 : 2
                params.isEntirety = 0
                params.isType = 1
                params.classStateType = params.data.isCopyNane
                params.data.customSeriesInfo = {  startTime: this.dateTimeList.length > 0 ? this.dateTimeList[0] : '', endTime: this.dateTimeList.length > 0 ? this.dateTimeList[1] : '' }

                params.regionName = this.regionName
                params.classType = this.newClassType
                params.teacherId = this.teacherName
                params.teacherStatus = this.teacherStatus,
                params.subjectGroupId = this.SubjectGroup

                this.params_ZUJIAN = params;
                this.showPopUpNotification = true;
           });

            // 纯补课饼图
           makeupPie.on('click', params => {
               console.info(params);
               params.stateType = params.data && params.data.name === '未成功' ? 0 :  params.data && params.data.name === '未知' ? 'null' : params.data && params.data.name === '已成功' ? 1 : 2
               params.isEntirety = 0
               params.isType = 1
               params.classStateType = params.data.isCopyNane
               params.data.customSeriesInfo = {  startTime: this.dateTimeList.length > 0 ? this.dateTimeList[0] : '', endTime: this.dateTimeList.length > 0 ? this.dateTimeList[1] : '' }

               params.regionName = this.regionName
               params.classType = this.newClassType
               params.teacherId = this.teacherName
               params.teacherStatus = this.teacherStatus, 
               params.subjectGroupId = this.SubjectGroup

               this.params_ZUJIAN = params;
               this.showPopUpNotification = true;
           });  




            window.addEventListener('resize', () => {
                chartInstance.resize();
                offlinePie.resize();
                planPie.resize();
                makeupPie.resize();
            })

        })

        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)

      })

    },


    handleGetDateList(){

      let data = {
          pageIndex: this.pageNum,
          pageSize: this.pageSize,
          startTime: this.dateTimeList .length > 1 ? this.dateTimeList[0] : '',
          endTime: this.dateTimeList .length > 1 ? this.dateTimeList[1] : '',
          teacherId: this.teacherName,
          regionName: this.regionName,
          classType: this.newClassType,
          teacherStatus: this.teacherStatus,
          subjectGroupId: this.SubjectGroup,
      }
     
      axios.post(`${apiBaseUrl}/firstRecordDiagram/querySubjectFirstDiagram`, data ,{ headers: {'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
         if(res.data.code === 200){
            if(res.data.code === 200){

              let data = res.data.data.entity
              this.pageNum = res.data.data.pageIndex
              this.pageSize = res.data.data.pageSize
              this.total = res.data.data.allTotal


              res.data.data = [
                {
                  
                  entiretyBlank: Number(data.entiretyBlank),
                  entiretySuccess: Number(data.entiretySuccess),
                  entiretyUnknown: Number(data.entiretyUnknown),
                  entiretyBlankNum: Number(data.entiretyBlankNum),
                  entiretySuccessNum: Number(data.entiretySuccessNum),
                  entiretyUnknownNum: Number(data.entiretyUnknownNum),

                  offlineBlank: Number(data.offlineBlank),
                  offlineSuccess: Number(data.offlineSuccess),
                  offlineUnknown: Number(data.offlineUnknown),
                  offlineBlankNum: Number(data.offlineBlankNum),
                  offlineSuccessNum: Number(data.offlineSuccessNum),
                  offlineUnknownNum: Number(data.offlineUnknownNum),

                  projectBlank: Number(data.projectBlank),
                  projectSuccess: Number(data.projectSuccess),
                  projectUnknown: Number(data.projectUnknown),
                  projectBlankNum: Number(data.projectBlankNum),
                  projectSuccessNum: Number(data.projectSuccessNum),
                  projectUnknownNum: Number(data.projectUnknownNum),

                  cramBlank: Number(data.cramBlank),
                  cramSuccess: Number(data.cramSuccess),
                  cramUnknown: Number(data.cramUnknown),
                  cramBlankNum: Number(data.cramBlankNum),
                  cramSuccessNum: Number(data.cramSuccessNum),
                  cramUnknownNum: Number(data.cramUnknownNum),

                }


                  
              ]

              this.dataTableList = data.tages
              this.dateList = res.data.data

              let arr = []

              res.data.data.map((item) => {
                  arr.push({

                        entiretyBlank: Number(item.entiretyBlank),
                        entiretySuccess: Number(item.entiretySuccess),
                        entiretyUnknown: Number(item.entiretyUnknown),
                        entiretyBlankNum: Number(item.entiretyBlankNum),
                        entiretySuccessNum: Number(item.entiretySuccessNum),
                        entiretyUnknownNum: Number(item.entiretyUnknownNum),

                        offlineBlank: Number(item.offlineBlank),
                        offlineSuccess: Number(item.offlineSuccess),
                        offlineUnknown: Number(item.offlineUnknown),
                        offlineBlankNum: Number(item.offlineBlankNum),
                        offlineSuccessNum: Number(item.offlineSuccessNum),
                        offlineUnknownNum: Number(item.offlineUnknownNum),
                        
                        projectBlank: Number(item.projectBlank),
                        projectSuccess: Number(item.projectSuccess),
                        projectUnknown: Number(item.projectUnknown),
                        projectBlankNum: Number(item.projectBlankNum),
                        projectSuccessNum: Number(item.projectSuccessNum),
                        projectUnknownNum: Number(item.projectUnknownNum),

                        cramBlank: Number(item.cramBlank),
                        cramSuccess: Number(item.cramSuccess),
                        cramUnknown: Number(item.cramUnknown),
                        cramBlankNum: Number(item.cramBlankNum),
                        cramSuccessNum: Number(item.cramSuccessNum),
                        cramUnknownNum: Number(item.cramUnknownNum),  
                  })
              })
              
              this.chartData = arr.length > 0 ? arr : []


              console.log(this.chartData, '?>>>>>>>>>>>>>>>>>>>>>>')


              this.$nextTick(() => {
                  this.initCharts()
              })

            }else{
              this.dateList = []
              this.chartData = []
              this.dataTableList = []
              this.$message({ type: 'error', message: res.data.message ? res.data.message : '出错了，请联系管理员~'  })
            }
         }else{
            this.dateList = []
            this.chartData = []
            this.dataTableList = []
            this.$message({ type: 'error', message: res.data.message ? res.data.message : '出错了，请联系管理员~'  })
             setTimeout(() => {
              loadingUtils.endLoading()
            }, 500)
         }
      }).catch(err => {
         this.dateList = []
         this.chartData = []
         this.dataTableList = []
         this.$message({ type: 'error', message: err.message ? err.message : '出错了，请联系管理员~'  })
          setTimeout(() => {
            loadingUtils.endLoading()
          }, 500)
      })

    },


    getChartOption(itmeIndex) {

      // let isTyleText = '月'
      // let isTyleText =  this.calculationMethod === 1 ? '日' : '月'
     
      return {
        title: {
          // text: isTyleText === '月' ? this.getYearRange(this.dateList[itmeIndex].startDate) + '年' + '' + this.getMonthRange(this.dateList[itmeIndex].startDate)  + '首次课成功率' : isTyleText === '日' ? '首次课成功率' : '',
          // subtext:  isTyleText === '月' ? '' : this.dateList[itmeIndex].startDate +' ~ ' + this.dateList[itmeIndex].endDate,
          left: 'center',
          minAngle: 5,
          textStyle: { 
            fontSize: 14, 
            color: '#333',
            verticalAlign: 'top'  
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
          },
        },
        legend: {
           orient: 'horizontal',
           left: 'left',
           top: -5,
           data: ['已成功', '未成功', '未知'],
           icon: 'circle', // 让图例变成圆点
           selectedMode: false 
        },
        series: [
          {
            minAngle: 5,
            name: '课消渠道',
            type: 'pie',
            radius: '60%',
            center: ['50%', '70%'], // 这里第二个参数越大越往下
            data: [
                { 
                  percent: this.chartData[itmeIndex] && this.chartData[itmeIndex].entiretySuccessNum ? this.chartData[itmeIndex].entiretySuccessNum : 0, 
                  value: this.chartData[itmeIndex] && this.chartData[itmeIndex].entiretySuccess ? this.chartData[itmeIndex].entiretySuccess : 0, 
                  name: '已成功' 
                },
                { 
                  percent: this.chartData[itmeIndex] && this.chartData[itmeIndex].entiretyBlankNum ? this.chartData[itmeIndex].entiretyBlankNum : 0, 
                  value: this.chartData[itmeIndex] && this.chartData[itmeIndex].entiretyBlank ? this.chartData[itmeIndex].entiretyBlank : 0, 
                  name: '未成功' 
                },
                { 
                  percent: this.chartData[itmeIndex] && this.chartData[itmeIndex].entiretyUnknownNum ? this.chartData[itmeIndex].entiretyUnknownNum : 0, 
                  value: this.chartData[itmeIndex] && this.chartData[itmeIndex].entiretyUnknown ? this.chartData[itmeIndex].entiretyUnknown : 0, 
                  name: '未知' 
                }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: function (params) {
                return params.name + ': ' + params.data.percent + ' (' + params.value + '%)';
              },
            },
            itemStyle: {
              color: function(params) {
                let colorList = ['#4472c4', '#3dc6c1', '#f6c846'] 
                return colorList[params.dataIndex];
              }
            },
          }
        ]
      }
    },


    getMonthRange(dateString) {
      if (dateString) {
        const parts = dateString.split('-');
        if (parts.length >= 2) {
            return parseInt(parts[1], 10); 
        } else {
            throw new Error('Invalid date format');
        }
      } else {
        return '';
      }
     
    },

    // 获取年份
    getYearRange(dateString) {
      if (dateString) {
        const year = dateString.substring(0, 4);
        return year;
      }else {
        return '';
      }
    },


   

  },


}


</script>




<style  scoped>

.btns{
   background-color: #428BCA;
   border-color: #428BCA;
   color: #fff;
}



</style>




// WEBPACK FOOTER //
// src/CourseTypeAnalysisEchart/FistClassTable/FistClassTableTeacherEndcopy.vue